import { capitalize } from 'lodash';
import { isCompletePet } from '../guard';
import { formatMultipetText } from '../functions';
import { ACTIONS } from '../constants';

export const resolveOnboardingPets = ({ pet, cart, cachedCart }) => {
  const liveCartReady = Boolean(cart?.cart_id);
  const resolvedPets = liveCartReady
    ? cart?.pets ?? []
    : cachedCart?.pets ?? [];
  const resolvedPet =
    (pet?.id ? pet : null) ??
    resolvedPets.find(candidate => !isCompletePet(candidate)) ??
    resolvedPets[0];

  return { liveCartReady, resolvedPets, resolvedPet };
};

export const getOtherPetsInCart = (resolvedPets, resolvedPetId) =>
  (resolvedPets ?? []).filter(
    otherPet => otherPet?.id !== resolvedPetId && isCompletePet(otherPet),
  );

export const getAllCompletePets = pets =>
  (pets ?? []).filter(pet => isCompletePet(pet));

export const getCapitalizedPetNames = pets =>
  getAllCompletePets(pets)
    .map(pet => capitalize(pet?.name))
    .filter(Boolean);

export const resolveAbandonerMenuConfig = ({
  bucket,
  resolvedPet,
  resolvedPets,
  quizContent,
  planContent,
  checkoutContent,
  pageProps,
}) => {
  if (!resolvedPet || !bucket) {
    return { shouldFallBackToIntro: true };
  }

  const otherPetsInCart = getOtherPetsInCart(resolvedPets, resolvedPet.id);
  const otherPetNames = otherPetsInCart
    .map(pet => capitalize(pet?.name))
    .filter(Boolean);
  const allPupNames = getCapitalizedPetNames(resolvedPets);

  if (bucket === 'beforeMealPrep') {
    const content = quizContent?.[0] ?? pageProps;

    return {
      shouldFallBackToIntro: false,
      content,
      primaryAction: ACTIONS.toPupName(),
      secondaryActions: content?.secondaryCtaText
        ? [
            {
              action: ACTIONS.toPupName({ reviewQuiz: true }),
              secondaryCtaTextTemplate: content.secondaryCtaText,
              pet: resolvedPet,
            },
          ]
        : [],
      multipetBannerText: formatMultipetText(
        content?.multipetCallout,
        otherPetNames,
      ),
    };
  }

  if (bucket === 'afterMealPrep') {
    const content = planContent?.[0] ?? pageProps;

    return {
      shouldFallBackToIntro: false,
      content,
      primaryAction: ACTIONS.toRecommendedPlan({ pet: resolvedPet }),
      secondaryActions: content?.secondaryCtaText
        ? [
            {
              action: ACTIONS.toPupName({ reviewQuiz: true }),
              secondaryCtaTextTemplate: content.secondaryCtaText,
              pet: resolvedPet,
            },
          ]
        : [],
      multipetBannerText: formatMultipetText(
        content?.multipetCallout,
        otherPetNames,
      ),
    };
  }

  if (bucket === 'atCheckout') {
    const content = {
      ...(checkoutContent?.[0] ?? pageProps),
      headline: formatMultipetText(checkoutContent?.[0]?.headline, allPupNames),
    };

    return {
      shouldFallBackToIntro: false,
      content,
      primaryAction: ACTIONS.toCheckout(),
      secondaryActions: getAllCompletePets(resolvedPets).map(otherPet => ({
        action: ACTIONS.toRecommendedPlan({ pet: otherPet }),
        secondaryCtaTextTemplate: content?.secondaryCtaText,
        pet: otherPet,
      })),
      multipetBannerText: undefined,
    };
  }

  return { shouldFallBackToIntro: true };
};
